<template>
  <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Manage Payments</p>
      <BaseRoundedButton @click="handleCreateSideBar">
        <p class="font-sans">Create New</p>
      </BaseRoundedButton>
    </div>
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-md">
            <th class="py-2 font-normal">Bank Logo</th>
            <th class="py-2 font-normal">Bank Name</th>
            <th class="py-2 font-normal">Account Holder</th>
            <th class="py-2 font-normal">Account Number</th>
            <th class="py-2 font-normal">QR-Code</th>
            <th class="py-2 px-2 font-normal">Payment Link</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="payment in payments" :key="payment.id" class="text-lg">
            <td>
              <img
                class="rounded-md w-16 h-16 object-scale-down my-2"
                :src="payment.bank_logo"
                alt=""
              />
            </td>
            <td class="px-1">{{ payment.bank_name }}</td>
            <td class="px-1">{{ payment.account_holder }}</td>
            <td class="px-1">{{ payment.account_number }}</td>
            <td class="px-1">
              <img
                class="rounded-md vertical_rect_img w-20 object-scale-down my-2"
                :src="payment.image_qr"
                alt=""
              />
            </td>
            <td class="w-96 px-2">{{ payment.link_qr }}</td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton
                    ><EllipsisVerticalIcon
                      class="w-8 h-8 text-black hover:text-blue cursor-pointer"
                  /></MenuButton>
                  <MenuItems
                    class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-8
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    "
                  >
                    <MenuItem
                      @click="handleEdit(payment)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <PencilIcon class="text-blue w-5 h-5 mr-4" />
                        <p class="text-blue">Edit</p>
                      </div>
                    </MenuItem>
                    <MenuItem
                      @click="handleDelete(payment.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <TrashIcon class="text-red w-5 h-5 mr-4" />
                        <p class="text-red">Delete</p>
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- create and update side bar -->
  <SideBar v-show="showCreateSideBar" @close-modal="handleCreateSideBar">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <h1 v-if="!updateFlag" class="text-blue text-2xl">Create New Payment</h1>
      <h1 v-else class="text-blue text-2xl">Update Payment</h1>
      <!-- body -->
      <div class="space-y-4 mb-8">
        <div>
          <div class="group py-4 cursor-pointer">
            <p class="text-gray mb-2 font-light text-center">Bank Logo</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input
              ref="imageFileUploader"
              class="hidden"
              type="file"
              name="profileImage"
              id="profileImage"
              @change="handleFileUpload($event)"
            />
            <div class="relative flex justify-center">
              <img
                v-if="bankLogoUrl"
                @click="handleFileImport"
                class="w-2/4 square_img object-scale-down rounded-lg mb-2"
                :src="bankLogoUrl"
                alt=""
              />
              <img
                v-else
                @click="handleFileImport"
                class="w-2/4 square_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg"
                alt=""
              />
              <div
                v-show="bankLogoUrl"
                @click="handleClearImage"
                class="
                  flex
                  items-center
                  justify-center
                  p-3
                  bg-red
                  rounded-full
                  absolute
                  right-12
                  top-0
                  cursor-pointer
                "
              >
                <TrashIcon class="text-white h-6 w-6" />
              </div>
            </div>
            <p
              v-if="bankLogoUrl"
              @click="handleFileImport"
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Change bank logo
            </p>
            <p
              v-else
              @click="handleFileImport"
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Add bank logo
            </p>
          </div>
        </div>
        <base-text-input
          v-model="bankName"
          name="bankName"
          isAutoComplete="off"
          label="Bank Name"
        />
        <base-text-input
          v-model="accountHolder"
          name="accountHolder"
          isAutoComplete="off"
          label="Account Holder"
        />
        <base-text-input
          v-model="accountNumber"
          name="accountNumber"
          isAutoComplete="off"
          label="Account Number"
        />
        <div>
          <div class="group py-4 cursor-pointer">
            <p class="text-gray mb-2 font-light">Qr-Code Payment Image</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input
              ref="QrCodeFileUploader"
              class="hidden"
              type="file"
              name="profileImage"
              id="profileImage"
              @change="handleQrCodeUpload($event)"
            />
            <div class="relative flex justify-center">
              <img
                v-if="qrImageUrl"
                @click="handleQrCodeImport"
                class="
                  w-full
                  vertical_rect_img
                  object-scale-down
                  rounded-lg
                  mb-2
                "
                :src="qrImageUrl"
                alt=""
              />
              <img
                v-else
                @click="handleQrCodeImport"
                class="w-full vertical_rect_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg"
                alt=""
              />
              <div
                v-show="qrImageUrl"
                @click="handleClearQrImage"
                class="
                  flex
                  items-center
                  justify-center
                  p-3
                  bg-red
                  rounded-full
                  absolute
                  right-0
                  top-0
                  cursor-pointer
                "
              >
                <TrashIcon class="text-white h-6 w-6" />
              </div>
            </div>
            <p
              v-if="qrImageUrl"
              @click="handleQrCodeImport"
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Change qrcode image
            </p>
            <p
              v-else
              @click="handleQrCodeImport"
              class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              "
            >
              Add qr-code image
            </p>
          </div>
        </div>
        <base-text-input
          v-model="linkPayment"
          name="linkPayment"
          isAutoComplete="off"
          label="Link Payment"
        />
      </div>
      <!-- action bottom button -->
      <div
        class="
          flex flex-row
          items-center
          justify-between
          space-x-4
          mt-auto
          pb-8
        "
      >
        <BaseRoundedButton
          @click="handleCreateSideBar"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton
          v-if="!updateFlag"
          @click="handleSavePayment"
          class="w-4/6"
        >
          <p>Create Payment</p>
        </BaseRoundedButton>
        <BaseRoundedButton v-else @click="handleSaveUpdate" class="w-4/6">
          <p>Update Payment</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import userService from "../Services/user.service";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import {
  PencilIcon,
  TrashIcon,
  EllipsisVerticalIcon,
} from "@heroicons/vue/24/outline";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import { useToast } from "vue-toastification";
export default {
  name: "ManagePayment",
  components: {
    BaseRoundedButton,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    PencilIcon,
    TrashIcon,
    EllipsisVerticalIcon,
    SideBar,
    BaseTextInput,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showCreateSideBar: false,
      updateFlag: false,
      bankLogoUrl: "",
      bankLogoFile: "",
      bankName: "",
      accountHolder: "",
      accountNumber: "",
      qrImageUrl: "",
      qrImageFile: "",
      linkPayment: "",
      tempId: "",
      payments: [],
    };
  },
  methods: {
    getPayments() {
      userService.getPaymentList().then((response) => {
        this.payments = response.data.data;
      });
    },
    handleCreateSideBar() {
      this.showCreateSideBar = !this.showCreateSideBar;
      this.updateFlag = false;
      if (!this.updateFlag) {
        this.bankLogoUrl = "";
        this.bankLogoFile = "";
        this.bankName = "";
        this.accountHolder = "";
        this.accountNumber = "";
        this.qrImageUrl = "";
        this.qrImageFile = "";
      }
    },
    handleFileImport() {
      this.$refs.imageFileUploader.click();
    },
    handleFileUpload(event) {
      this.bankLogoFile = event.target.files[0];
      this.bankLogoUrl = URL.createObjectURL(this.bankLogoFile);
    },
    handleClearImage() {
      this.bankLogoUrl = "";
      this.bankLogoFile = "";
    },
    handleQrCodeImport() {
      this.$refs.QrCodeFileUploader.click();
    },
    handleQrCodeUpload(event) {
      this.qrImageFile = event.target.files[0];
      this.qrImageUrl = URL.createObjectURL(this.qrImageFile);
    },
    handleClearQrImage() {
      this.qrImageUrl = "";
      this.qrImageFile = "";
    },
    handleSavePayment() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("bank_logo", this.bankLogoFile);
      formData.append("bank_name", this.bankName);
      formData.append("account_holder", this.accountHolder);
      formData.append("account_number", this.accountNumber);
      formData.append("image_qr", this.qrImageFile);
      formData.append("link_qr", this.linkPayment);

      userService
        .storePayment(formData)
        .then(() => {
          this.$Progress.finish();
          this.getPayments();
          this.bankLogoUrl = "";
          this.bankLogoFile = "";
          this.bankName = "";
          this.accountHolder = "";
          this.accountNumber = "";
          this.qrImageUrl = "";
          this.qrImageFile = "";
          this.showCreateSideBar = false;
          this.toast.success("Create new payment successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.$Progress.error("Error! Fail to create new paymet.");
          console.log(error);
        });
    },
    handleDelete(id) {
      this.$Progress.start();
      userService
        .delPayment(id)
        .then(() => {
          this.$Progress.finish();
          this.getPayments();
          this.toast.success("Delete payment successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Fail to delete payment.");
          console.log(error);
        });
    },
    handleEdit(value) {
      this.updateFlag = true;
      this.tempId = value.id;
      this.bankLogoUrl = value.bank_logo;
      this.bankName = value.bank_name;
      this.accountHolder = value.account_holder;
      this.accountNumber = value.account_number;
      this.qrImageUrl = value.image_qr;
      this.linkPayment = value.link_qr;
      this.showCreateSideBar = !this.showCreateSideBar;
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("bank_name", this.bankName);
      formData.append("account_holder", this.accountHolder);
      formData.append("account_number", this.accountNumber);
      formData.append("link_qr", this.linkPayment);
      if (this.bankLogoFile || !this.bankLogoUrl) {
        formData.append("bank_logo", this.bankLogoFile);
      }
      if (this.qrImageFile || !this.qrImageUrl) {
        formData.append("image_qr", this.qrImageFile);
      }

      userService
        .storeUpdatePayment(this.tempId, formData)
        .then(() => {
          this.$Progress.finish();
          this.bankLogoUrl = "";
          this.bankLogoFile = "";
          this.bankName = "";
          this.accountHolder = "";
          this.accountNumber = "";
          this.qrImageUrl = "";
          this.qrImageFile = "";
          this.getPayments();
          this.showCreateSideBar = false;
          this.toast.success("Update paymentSuccessful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Fail to update payment.");
          console.log(error);
        });
    },
  },
  created() {
    this.$Progress.start();
    this.getPayments();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.square_img {
  aspect-ratio: 1/1;
}
.vertical_rect_img {
  aspect-ratio: 9/16;
}
</style>